import type { ThemeMode } from '../prefs'

export interface ChartColors {
  categoryColors: string[]
  axisColor: string
  gridColor: string
  legendColor: string
  tooltipBg: string
  tooltipText: string
}

export function getChartColors(theme: ThemeMode): ChartColors {
  if (theme === 'green') {
    return {
      categoryColors: ['#1565c0', '#2e7d32', '#e65100', '#ad1457', '#6a1b9a', '#00695c', '#bf360c', '#37474f'],
      axisColor: '#6b8b6b',
      gridColor: '#a8cda8',
      legendColor: '#1a2e1a',
      tooltipBg: '#e5f5e4',
      tooltipText: '#1a2e1a',
    }
  }
  return {
    categoryColors: ['#4a90d9', '#5cb85c', '#f0ad4e', '#d9534f', '#9b59b6', '#1abc9c', '#e74c3c', '#2c3e50'],
    axisColor: '#888888',
    gridColor: '#e0e0e0',
    legendColor: '#333333',
    tooltipBg: '#ffffff',
    tooltipText: '#333333',
  }
}
